export default "__VITE_ASSET__BdXqGzZt__"